
import React, { useState, useEffect } from "react";
import { Button, Box, Typography, Card, IconButton } from "@mui/material";
import Header from '../Header';
import Footer from '../Footer';
import Dropdown from "./Dropdown";
import { styles } from '../../styles/styles';
import { DecorativeCorner } from '../../common/DecorativeCorner';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
const shortlistedProfiles = [
    {
        id: 1,
        image: "/images/women.jpeg",
        name: "Gayatri Devi",
        profession: "Software Engineer",
        Profileid: "AM101302",
        Age: "28",
        Location: "Bangalore",
    },
    {
        id: 2,
        image: "/images/women.jpeg",
        name: "Gayatri Devi",
        profession: "Software Engineer",
        Profileid: "AM102345",
        Age: "30",
        Location: "Hyderabad",
    },
    {
        id: 3,
        name: "Gayatri Devi",
        image: "/images/women.jpeg",
        profession: "Software Engineer",
        Profileid: "AM103567",
        Age: "26",
        Location: "Chennai",
    },
];
const blocklistedProfiles = [{
    id: 1,
    image: "/images/women.jpeg",
    name: "Gayatri Devi",
    profession: "Software Engineer",
    Profileid: "AM101302",
    Age: "28",
    Location: "Bangalore",
},
{
    id: 2,
    image: "/images/women.jpeg",
    name: "Gayatri Devi",
    profession: "Software Engineer",
    Profileid: "AM102345",
    Age: "30",
    Location: "Hyderabad",
},
{
    id: 3,
    name: "Gayatri Devi",
    image: "/images/women.jpeg",
    profession: "Software Engineer",
    Profileid: "AM103567",
    Age: "26",
    Location: "Chennai",
},];
const viewedProfiles = [{
    id: 1,
    image: "/images/women.jpeg",
    name: "Gayatri Devi",
    profession: "Software Engineer",
    Profileid: "AM101302",
    Age: "28",
    Location: "Bangalore",
},
{
    id: 2,
    image: "/images/women.jpeg",
    name: "Gayatri Devi",
    profession: "Software Engineer",
    Profileid: "AM102345",
    Age: "30",
    Location: "Hyderabad",
},
{
    id: 3,
    name: "Gayatri Devi",
    image: "/images/women.jpeg",
    profession: "Software Engineer",
    Profileid: "AM103567",
    Age: "26",
    Location: "Chennai",
},];
const viewedMyProfile = [{
    id: 1,
    image: "/images/women.jpeg",
    name: "Gayatri Devi",
    profession: "Software Engineer",
    Profileid: "AM101302",
    Age: "28",
    Location: "Bangalore",
},
{
    id: 2,
    image: "/images/women.jpeg",
    name: "Gayatri Devi",
    profession: "Software Engineer",
    Profileid: "AM102345",
    Age: "30",
    Location: "Hyderabad",
},
{
    id: 3,
    name: "Gayatri Devi",
    image: "/images/women.jpeg",
    profession: "Software Engineer",
    Profileid: "AM103567",
    Age: "26",
    Location: "Chennai",
},];

const Dashboard = () => {

    const [selectedCategory, setSelectedCategory] = useState("Shortlisted");

    const getProfilesToDisplay = () => {
        switch (selectedCategory) {
            case "Shortlisted":
                return shortlistedProfiles;
            case "Blocklisted":
                return blocklistedProfiles;
            case "Profiles Viewed":
                return viewedProfiles;
            case "Viewed My Profile":
                return viewedMyProfile;
            default:
                return [];
        }
    };

    const profiles = getProfilesToDisplay();
    const categories = [
        { name: "Shortlisted", count: "05" },
        { name: "Blocklisted", count: "20" },
        { name: "Profiles Viewed", count: "05" },
        { name: "Viewed My Profile", count: "05" },
    ];

    return (
        <Box>
            <Header />
            <Box sx={{ marginTop: "6.2%" }}>
                <Dropdown />
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    height: "auto",
                }}
            >
                <Box sx={{ width: { xs: "100%", sm: "250px" }, paddingLeft: { xs: "0px", sm: "20px" }, paddingTop: { xs: "10px", sm: "40px" } }}>
                    {categories.map((item) => (
                        <Button
                            key={item.name}
                            fullWidth
                            sx={{
                                fontFamily: '"SF Pro Display", sans-serif',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '100%',
                                letterSpacing: '0%',
                                width: { xs: "100%", sm: "257px" },
                                height: "54px",
                                padding: "10px",
                                borderRadius: "0px",
                                backgroundColor: selectedCategory === item.name ? "#B56E2C" : "white",
                                color: selectedCategory === item.name ? "white" : "black",
                                textTransform: "none",
                                justifyContent: "space-between",
                            }}
                            onClick={() => setSelectedCategory(item.name)}
                        >
                            <span>{item.name}</span>
                            <IconButton
                                sx={{
                                    fontFamily: '"SF Pro Display", sans-serif',
                                    fontWeight: 700,
                                    fontSize: '15px',
                                    backgroundColor: selectedCategory === item.name ? "white" : "#B56E2C",
                                    color: selectedCategory === item.name ? 'black' : "white",
                                }}
                            >
                                {item.count}
                            </IconButton>
                        </Button>
                    ))}
                </Box>

                <Box sx={{ flex: 1, backgroundColor: "#fff4e5", padding: "20px" }}>
                    {profiles.map((profile, idx) => (
                        <Card key={idx} sx={{ ...styles.cardShortlisted,
                            padding:{xs:"10px",sm:"30px"}
                        }}>
                            <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                            <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                            <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                            <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                            <Box sx={{
                                
                                 width: "100%",
                                 padding: { xs: "15px", sm: "10px" },
                                 boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                 border: "2px solid rgb(224, 141, 64)",
                                 display: "flex",
                                 flexDirection: "column",
                                 borderRadius:"10px",
                                 margin: "0 auto",
                            }}>
                            <Box>
                            <img src={profile.image} alt={profile.name} style={{ width: "80px", height: "80px", borderRadius: "10px" }} />

                                <Typography variant="h6" color="brown">{profile.name}</Typography>
                                <Typography variant="body2">{profile.details}</Typography>
                                <Box sx={{ mt: 1 }}>
                                    <Button variant="outlined" color="warning" size="small" sx={{ mr: 1 }}>View Profile</Button>
                                    <Button variant="contained" color="success" size="small">Send Interest</Button>
                                </Box>
                            </Box>
                            </Box>

                        </Card>
                    ))}

                </Box>
            </Box>

            <Footer />
        </Box>
    );
};

export default Dashboard;


